import { useState } from "react";
import useDebtWarehouseRemovedTab from "../../hooks/useDebtWarehouseRemovedTab";
import { Stack, Box, Typography } from "@mui/material";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import TableComp from "src/components/shared/table/TableComp";
import DebtFilter from "../../components/DebtFilter";
import { formatCurrency } from "src/helper/convertNum";
import convertCurrency from "src/helper/convertCurrency";

const DebtWarehouseRemovedTab = ({ date }) => {
  const [keyWord, setKeyWord] = useState();
  const [filter, setFilter] = useState();
  const { bodyList, sortData, header, pagi, setPagi, total, totalDiscardedValue } = useDebtWarehouseRemovedTab({ date, keyWord, filter });

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        my="14px"
      >
        <Box
          display="flex"
          gap="6px"
          alignItems="flex-start"
          minWidth="198px"
        >
          <SearchFilterComp
            getSearchKeyword={setKeyWord}
            placeholder="Mã phiếu xuất"
            width="100%"
          />
        </Box>
        <Stack
          direction="row"
          gap={2}
          alignItems="center"
          justifyContent="flex-end"
        >
          <DebtFilter
            variant="debt-removed"
            setParamsQuery={setFilter}
            paramsQuery={filter}
          />
        </Stack>
      </Stack>
      <TableComp
        bodyList={bodyList}
        headers={header}
        sortData={sortData}
        setPagi={setPagi}
        pagi={pagi}
        total={total}
        noBackground
        TableFooterComponent={
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            spacing={4}
            sx={{ py: 2, borderTop: "1px solid var(--grey)" }}
          >
            <Typography fontWeight="bold">Tổng:</Typography>
            <Stack alignItems="center">
              <Typography fontWeight="bold">
                {totalDiscardedValue >= 0 ? "+" : ""} {formatCurrency(totalDiscardedValue) ?? 0}
              </Typography>
              {totalDiscardedValue && (
                <Typography
                  color="#989898"
                  fontSize="8px"
                  fontStyle="italic"
                >
                  {convertCurrency(totalDiscardedValue ?? 0)} đồng
                </Typography>
              )}
            </Stack>
          </Stack>
        }
      />
    </>
  );
};

export default DebtWarehouseRemovedTab;
